import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";

const FloraCarePlus = () => {
  const navigate = useNavigate();

  useEffect(() => {
    document.body.className = "premium-light-vibe";
    return () => {
      document.body.className = "";
    };
  }, []);

  // 100% Guaranteed Icons (SVGs)
  const Tick = () => (
    <svg
      width="22"
      height="22"
      viewBox="0 0 24 24"
      fill="none"
      stroke="#4caf50"
      strokeWidth="3"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <polyline points="20 6 9 17 4 12"></polyline>
    </svg>
  );

  const Cross = () => (
    <svg
      width="22"
      height="22"
      viewBox="0 0 24 24"
      fill="none"
      stroke="#d63031"
      strokeWidth="3"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <line x1="18" y1="6" x2="6" y2="18"></line>
      <line x1="6" y1="6" x2="18" y2="18"></line>
    </svg>
  );

  const premiumFeatures = [
    {
      icon: "fa-brain",
      color: "#e91e63",
      title: "AI Cycle Predictions",
      desc: "Advanced neural patterns to predict your next cycle and hormonal symptoms with 99.9% accuracy.",
    },
    {
      icon: "fa-baby",
      color: "#2196f3",
      title: "Smart BabyCare Vault",
      desc: "Digital vaccination records and growth tracking with automatic milestone reminders.",
    },
    {
      icon: "fa-user-md",
      color: "#4caf50",
      title: "Priority Doctor Chat",
      desc: "Get instant access to verified gynecologists and pediatricians without any appointments.",
    },
    {
      icon: "fa-file-medical",
      color: "#9c27b0",
      title: "Medical Data Export",
      desc: "Generate professional health reports in PDF format to share with your personal doctor.",
    },
  ];

  return (
    <main
      style={{ background: "#fdfbfd", paddingBottom: "5rem", color: "#2d3436" }}
    >
      {/* 🚀 Hero Section */}
      <section
        style={{
          padding: "4rem 1rem",
          textAlign: "center",
          background: "linear-gradient(180deg, #fff0f5 0%, #ffffff 100%)",
        }}
      >
        <div className="container">
          <h1 style={{ fontSize: "3rem", fontWeight: "800" }}>
            FloraCare<span style={{ color: "#e91e63" }}>+</span> Premium
          </h1>
          <p
            style={{
              color: "#636e72",
              fontSize: "1.2rem",
              maxWidth: "700px",
              margin: "10px auto",
            }}
          >
            Your personal health companion, upgraded with elite features.
          </p>
        </div>
      </section>

      <div className="container">
        {/* 🌟 1. FEATURE GRID (Wapas Aa Gaya!) */}
        <div className="dashboard-grid" style={{ marginBottom: "5rem" }}>
          {premiumFeatures.map((f, i) => (
            <div
              key={i}
              className="card"
              style={{
                borderTop: `4px solid ${f.color}`,
                borderRadius: "15px",
              }}
            >
              <div className="card-icon" style={{ color: f.color }}>
                <i className={`fas ${f.icon}`}></i>
              </div>
              <h3>{f.title}</h3>
              <p style={{ color: "#636e72", fontSize: "0.9rem" }}>{f.desc}</p>
            </div>
          ))}
        </div>

        {/* 📊 2. COMPARISON TABLE (With SVGs) */}
        <section style={{ marginBottom: "5rem" }}>
          <h2 style={{ textAlign: "center", marginBottom: "2.5rem" }}>
            Free vs Premium Comparison
          </h2>
          <div
            style={{
              background: "#fff",
              borderRadius: "20px",
              overflow: "hidden",
              boxShadow: "0 10px 30px rgba(0,0,0,0.05)",
              border: "1px solid #eee",
            }}
          >
            <table style={{ width: "100%", borderCollapse: "collapse" }}>
              <thead style={{ background: "#f8f9fa" }}>
                <tr>
                  <th style={{ padding: "1.5rem", textAlign: "left" }}>
                    Health Services
                  </th>
                  <th style={{ padding: "1.5rem", textAlign: "center" }}>
                    Free
                  </th>
                  <th
                    style={{
                      padding: "1.5rem",
                      textAlign: "center",
                      color: "#e91e63",
                    }}
                  >
                    FloraCare+
                  </th>
                </tr>
              </thead>
              <tbody>
                {[
                  { name: "Cycle & Period Tracking", free: true, plus: true },
                  { name: "STI Risk Assessments", free: true, plus: true },
                  { name: "AI Prediction Engine", free: false, plus: true },
                  { name: "Baby Vaccine Vault", free: false, plus: true },
                  { name: "24/7 Expert Chat", free: false, plus: true },
                  { name: "Ad-Free Experience", free: false, plus: true },
                ].map((row, idx) => (
                  <tr key={idx} style={{ borderBottom: "1px solid #f1f1f1" }}>
                    <td style={{ padding: "1.2rem 1.5rem", fontWeight: "500" }}>
                      {row.name}
                    </td>
                    <td
                      style={{ padding: "1.2rem 1.5rem", textAlign: "center" }}
                    >
                      {row.free ? <Tick /> : <Cross />}
                    </td>
                    <td
                      style={{ padding: "1.2rem 1.5rem", textAlign: "center" }}
                    >
                      {row.plus ? <Tick /> : <Cross />}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </section>

        {/* 💳 3. PRICING CARD */}
        <div
          style={{
            textAlign: "center",
            background: "#fff",
            padding: "4rem 2rem",
            borderRadius: "40px",
            border: "2px solid #ffe4ec",
            boxShadow: "0 20px 40px rgba(233, 30, 99, 0.05)",
          }}
        >
          <h2 style={{ fontSize: "2.5rem" }}>Lifetime Premium Access</h2>
          <h1
            style={{
              fontSize: "4.5rem",
              fontWeight: "900",
              color: "#2d3436",
              margin: "1rem 0",
            }}
          >
            ₹999
          </h1>
          <p
            style={{
              color: "#e91e63",
              fontWeight: "bold",
              letterSpacing: "1px",
            }}
          >
            NO MONTHLY SUBSCRIPTIONS • PAY ONCE
          </p>

          <div
            style={{
              display: "flex",
              gap: "20px",
              justifyContent: "center",
              marginTop: "2.5rem",
            }}
          >
            <button
              className="btn btn-primary"
              style={{
                padding: "1.2rem 4rem",
                borderRadius: "50px",
                fontSize: "1.1rem",
              }}
            >
              Get FloraCare+ Now
            </button>
            <button
              className="btn btn-outline"
              onClick={() => navigate("/tracker")}
              style={{ borderRadius: "50px", padding: "1.2rem 3rem" }}
            >
              Maybe Later
            </button>
          </div>
        </div>
      </div>
    </main>
  );
};

export default FloraCarePlus;
